import { AccessorsMutatorsDecorator, Model } from "../../helpers";
import { CashDrawer } from "./cash-drawer.model";

/**
 * @class CashDrawer
 *
 */
export class CashDrawerTransaction extends Model {

    static get validationModel() {

        return {
            amount: {
                label: 'AMOUNT',
                messages: {
                    greaterThan: 'AMOUNT_SHOULD_BE_GREATER_THAN_0'
                }
            }
        };
    }

    /**
     * @param {Object|CashDrawer} value
     * @returns {CashDrawer}
     */
    setCashDrawer(value) {

        return value instanceof CashDrawer ? value : new CashDrawer(value);
    }
}

AccessorsMutatorsDecorator(
    'id',
    'cash_drawer',
    'amount',
    'notes',
    'guest_id',
    'created_at',
    'reservation',
    'house_account',
    'reservation_id',
    'house_account_id',
    'guest_name',
    'room_name',
    'expenses_item_id',
    'paid_to',
    'apply_vat',
    'voucher_id',
    'voucher_ident',
    'voucher_type',
    'vendor_id',
)(CashDrawerTransaction);



// WEBPACK FOOTER //
// ./src/pms-api/models/cash-drawer-transaction.model.js